import { refreshLink } from "./refreshLink";
import { authLink } from "./authLink";

export default [refreshLink, authLink];
